// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__pu3cv","title":"TextInput_title__CLtS-","textinput":"TextInput_textinput__aBtFO"};